import React, { useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';

async function copyText(value) {
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(value);
    return;
  }

  const input = document.createElement('textarea');
  input.value = value;
  input.setAttribute('readonly', '');
  input.style.position = 'fixed';
  input.style.opacity = '0';
  document.body.appendChild(input);
  input.select();
  document.execCommand('copy');
  document.body.removeChild(input);
}

export default function MockTestShareButton({ path, label = 'Copy test link', className, style }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (!path) return;
    try {
      await copyText(`${window.location.origin}${path}`);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1600);
    } catch (_) {
      setCopied(false);
    }
  };

  return (
    <Tooltip title={copied ? 'Link copied' : label}>
      <IconButton
        type="button"
        size="small"
        className={className}
        style={style}
        aria-label={label}
        onClick={handleCopy}
      >
        <ShareOutlinedIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
}
